import { asInstanceOf } from "@opendaw/lib-std";
import { IndexedBox } from "@opendaw/lib-box";
import { AudioUnitBox, RootBox } from "@opendaw/studio-boxes";
import { TransferUtils } from "./TransferUtils";
export var TransferAudioUnits;
(function (TransferAudioUnits) {
    /**
     * Copies audio units and their dependencies to a target project.
     * Preserved resources already present in the target graph are shared, not duplicated.
     * @returns the newly created audio unit boxes in the target graph
     */
    TransferAudioUnits.transfer = (audioUnitBoxes, { boxGraph: targetBoxGraph, mandatoryBoxes: { primaryAudioBusBox, rootBox } }, options = {}) => {
        const excludeBox = (box) => TransferUtils.shouldExclude(box)
            || (options?.excludeTimeline === true && TransferUtils.excludeTimelinePredicate(box));
        const dependencies = Array.from(audioUnitBoxes[0].graph.dependenciesOf(audioUnitBoxes, {
            alwaysFollowMandatory: true,
            stopAtResources: true,
            excludeBox
        }).boxes);
        const uuidMap = TransferUtils.generateMap(audioUnitBoxes, dependencies, rootBox.audioUnits.address.uuid, primaryAudioBusBox.address.uuid);
        TransferUtils.copyBoxes(uuidMap, targetBoxGraph, audioUnitBoxes, dependencies);
        TransferUtils.reorderAudioUnits(uuidMap, audioUnitBoxes, rootBox, options.insertIndex);
        const result = audioUnitBoxes.map(source => asInstanceOf(rootBox.graph
            .findBox(uuidMap.get(source.address.uuid, "uuid mapping").target)
            .unwrap("Target AudioUnit has not been copied"), AudioUnitBox));
        if (options.deleteSource === true) {
            const sourceRootBox = asInstanceOf(audioUnitBoxes[0].collection.targetVertex.unwrap("collection.target").box, RootBox);
            audioUnitBoxes.forEach(box => box.delete());
            IndexedBox.collectIndexedBoxes(sourceRootBox.audioUnits, AudioUnitBox)
                .forEach((box, index) => box.index.setValue(index));
        }
        return result;
    };
})(TransferAudioUnits || (TransferAudioUnits = {}));
